import { QUERY_KEYS } from './types'
import { AffiliateAlanStorage } from './affiliateAlanStorage.ts'
import { ApiCore } from '@monorepo/api'

export const getAffiliateData = ({
  bonusId,
  promocode,
  referralCode,
}: { bonusId?: number; promocode?: string; referralCode?: string } = {}) => {
  if (typeof window === 'undefined') return
  const urlParams = new URLSearchParams(window.location.search)

  const dataAlan: ApiCore.AlanUserRegistrationSchema | undefined = AffiliateAlanStorage.get()
  const dataPpp: ApiCore.PPPUserRegistrationSchema | undefined = {
    subId1: urlParams.get(QUERY_KEYS.AFFILIATE_PPP_SUB_ID_1) || undefined,
    subId2: urlParams.get(QUERY_KEYS.AFFILIATE_PPP_SUB_ID_2) || undefined,
    subId3: urlParams.get(QUERY_KEYS.AFFILIATE_PPP_SUB_ID_3) || undefined,
    subId4: urlParams.get(QUERY_KEYS.AFFILIATE_PPP_SUB_ID_4) || undefined,
    subId5: urlParams.get(QUERY_KEYS.AFFILIATE_PPP_SUB_ID_5) || undefined,
    st: urlParams.get(QUERY_KEYS.AFFILIATE_PPP_STREAM_ID) || undefined,
  }

  return {
    bonus_id: bonusId || undefined,
    // со слов бэка такой тип
    // referral_code: ReferralCode | PromoCode | None
    referral_code: referralCode || promocode || undefined,
    ppp: !dataAlan ? dataPpp : undefined,
    alan: dataAlan,
    stag: urlParams.get(QUERY_KEYS.AFFILIATE_AFFILKA) || undefined,
  }
}
